import parse from "html-react-parser";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useDeleteServicesIconMutation } from "../../features/services/servicesApi";
import swalWithBootstrapButtons from "../../hooks/swalWithBootstrapButtons";

export default function ServiceIconTableRow({ service = {} }) {
  const { id, iconTag } = service || {};
  const [
    deleteservicesIcon,
    { isSuccess: deletedIsSuccess, isError: deletedIsError },
  ] = useDeleteServicesIconMutation();
  useEffect(() => {
    if (!deletedIsError && deletedIsSuccess) {
      swalWithBootstrapButtons.fire(
        "Deleted!",
        "Service Tag Delete Successfully.",
        "success"
      );
    } else if (deletedIsError) {
      swalWithBootstrapButtons.fire(
        "Error",
        "Service Tag Delete Error! :)",
        "error"
      );
    }
  }, [deletedIsError, deletedIsSuccess]);

  const handleDelete = () => {
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          deleteservicesIcon(id);
        }
      });
  };

  return (
    <tr key={id} className="text-center">
      <td>
        <div className="feature-box-01">{parse(iconTag)}</div>
      </td>
      <td>
        <Link
          className="mx-2 btn btn-outline-success"
          to={`/user/service/icon/edit/${id}`}
        >
          Edit
        </Link>
        <button className="mx-2 btn btn-outline-danger" onClick={handleDelete}>
          Delete
        </button>
      </td>
    </tr>
  );
}
